import { ReactElement, useState } from 'react'
import { TableCell, TableRow } from '@mui/material'

import DevelopusTreeTableCell, {
  DevelopusTreeTableItemCellType,
} from './DevelopusTreeTableCell'
import { DevelopusTreeTableBodyType } from './DevelopusTreeTableBody'
import { KeyboardArrowRight, KeyboardArrowDown } from '@mui/icons-material'
import { UUID } from 'crypto'
import DevelopusMoreButton from '../button/DevelopusMoreButton'

export type DevelopusTreeTableItemType = {
  id?: UUID
  cells: DevelopusTreeTableItemCellType[]
  children: DevelopusTreeTableBodyType
}

interface Props {
  item: DevelopusTreeTableItemType
  handleEdit: (id?: UUID) => void
  handleRemove: (id?: UUID) => void
}

const childRowStyle = {
  '& > *': {
    paddingTop: '8px',
    paddingBottom: '8px',
    height: '10px',
  },
}

const DevelopusTableRow = (props: Props): ReactElement => {
  const [showChildren, setShowChildren] = useState(false)
  const { item } = props

  const containChildren = item.children.items.length > 0

  const toggleShowChildren = () => {
    if (containChildren) {
      setShowChildren(!showChildren)
    }
  }

  const handleEdit = () => {
    props.handleEdit(item.id)
  }

  const handleRemove = () => {
    props.handleRemove(item.id)
  }

  return (
    <>
      <TableRow>
        <TableCell onClick={toggleShowChildren}>
          {!showChildren && containChildren && (
            <KeyboardArrowRight style={{ cursor: 'pointer' }} />
          )}
          {!showChildren && !containChildren && (
            <KeyboardArrowRight style={{ color: '#c5c3c3d4' }} />
          )}
          {showChildren && <KeyboardArrowDown style={{ cursor: 'pointer' }} />}
        </TableCell>
        {item.cells.map((cell, idx) => (
          <DevelopusTreeTableCell key={idx} cell={cell} />
        ))}
        <TableCell sx={{ width: '20px' }}>
          <DevelopusMoreButton
            handleEdit={handleEdit}
            handleRemove={handleRemove}
          />
        </TableCell>
      </TableRow>

      {showChildren &&
        item.children.items.map((childItem, idx) => (
          <TableRow key={`child_${idx}`} sx={childRowStyle}>
            <TableCell />
            {childItem.cells.map((cell, cellIdx) => (
              <DevelopusTreeTableCell
                key={`child_${idx}_${cellIdx}`}
                cell={cell}
              />
            ))}
            <TableCell />
          </TableRow>
        ))}
    </>
  )
}

export default DevelopusTableRow
